import Reveal from "./Reveal";
import ChapterHeader from "./ChapterHeader";

export default function Process({ t }) {
  const c = t.chapter03;
  return (
    <section id="process" className="pb-20 md:pb-28">
      <ChapterHeader
        num={c.num}
        overline={c.overline}
        title={c.title}
        subtitle={c.subtitle}
      />
      <div className="container-x mt-14 md:mt-16">
        <div className="border-t border-[var(--border)]">
          {c.steps.map((s, i) => (
            <Reveal key={i} delay={i * 0.05} y={20}>
              <div
                className="group grid grid-cols-12 gap-4 md:gap-8 border-b border-[var(--border)] py-8 md:py-10 hover:bg-[#0a0a0a] transition-colors duration-500 px-2 md:px-4"
                data-testid={`process-step-${i}`}
              >
                <div className="col-span-2 md:col-span-1">
                  <div className="chapter-num text-3xl md:text-5xl leading-none group-hover:text-[var(--accent)] group-hover:[-webkit-text-stroke:0] transition-all">
                    {s.n}
                  </div>
                </div>
                <div className="col-span-10 md:col-span-4">
                  <div className="font-display font-black text-2xl md:text-4xl uppercase tracking-tighter text-[var(--text)] group-hover:text-[var(--accent)] transition-colors">
                    {s.t}
                  </div>
                </div>
                <div className="col-span-12 md:col-span-6 md:col-start-7">
                  <p className="text-[var(--text-muted)] leading-relaxed text-base md:text-lg">
                    {s.d}
                  </p>
                </div>
                <div className="hidden md:flex md:col-span-1 md:col-start-12 justify-end items-start pt-3">
                  <span className="text-[var(--text-muted)] group-hover:text-[var(--accent)] group-hover:translate-x-2 transition-all duration-500">
                    →
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
